import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TableData } from '../../../../../table-overlay/table-overlay';
import { Dimension2d, WordRect } from '@ps-gui/claims-terminal-shared';

@Component({
  selector: 'ct-extraction-table-overlay-context-menu',
  templateUrl: './table-overlay-context-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableOverlayContextMenuComponent {
  readonly tableData = input.required<TableData>();
  readonly absoluteTableRect = input.required<WordRect>();
  readonly dimension = input.required<Dimension2d>();

  deleteButtonClicked = output();
  editButtonClicked = output();
  magicWandButtonClicked = output();
}
